import { Button, ButtonProps, ModalFooter } from '@lessonup/ui-components';
import React from 'react';

type FooterProps = {
  backButton?: {
    onClick: () => void;
    label: string;
  } & Partial<ButtonProps>;
  nextButton: {
    onClick: () => void;
    label: string;
  } & Partial<ButtonProps>;
};

export const Footer = ({ backButton, nextButton }: FooterProps) => {
  const { label: backButtonLabel, ...backButtonProps } = backButton || {};
  const { label: nextButtonLabel, ...nextButtonProps } = nextButton;

  return (
    <ModalFooter type="withChildren" justifyContent={backButton ? 'space-between' : 'end'}>
      {backButton ? (
        <Button
          type="button"
          buttonType="white"
          {...backButtonProps}
          showStroke={true}
          buttonShape="rect"
          size="medium"
        >
          {backButtonLabel}
        </Button>
      ) : null}
      <Button type="button" buttonType="primary" {...nextButtonProps} buttonShape="rect" size="medium">
        {nextButtonLabel}
      </Button>
    </ModalFooter>
  );
};
